import NABundle from './NABundle';

export default function TabBundles() {
    return <NABundle />;
}
